import { Component, ElementRef, ViewChild } from '@angular/core';
import { AppMenu } from './app.menu';
import { LayoutService } from '@/layout/service/layout.service';
import { RouterModule } from '@angular/router';
import { AppTopbar } from '@/layout/components/app.topbar';
import { CommonModule } from '@angular/common';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [CommonModule, AppMenu, RouterModule, AppTopbar],
    template: ` <div class="layout-sidebar">
        <div class="sidebar-header">
            <!-- Brand lock-up: Logomark Full (white) | IDP. Logo guidelines
                 say to always start with the Logomark Full; the Badge is
                 reserved for small placements and only appears on mobile,
                 where the full mark no longer fits. -->
            <a class="logo" [routerLink]="['/']">
                <img class="logo-image logo-full" src="/layout/images/psabdp-logomark-white.png" alt="PSA BDP" />
                <img class="logo-image logo-badge" src="/layout/images/psabdp-badge-white.png" alt="PSA BDP" />
                <!-- <span class="logo-divider" aria-hidden="true"></span>
                <span class="app-name">IDP</span> -->
                </a
            >
        </div>

        <div #menuContainer class="layout-menu-container">
            <div app-menu></div>
        </div>

        <!-- Desktop: the top-bar actions occupy the right half of row 1 of the
             sidebar grid. On mobile the sidebar is an off-canvas drawer, so the
             top bar is rendered by app.layout instead. -->
        <div app-topbar *ngIf="!layoutService.isMobile()"></div>
    </div>`
})
export class AppSidebar {
    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef
    ) {}
}
